import { useTranslation } from 'react-i18next';

const Overview = () => {
  const { t } = useTranslation();

  return <div>{t('OverviewPage')}</div>;
};

export default Overview;
